import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import { DISCOUNT_CODE_TYPE, DISCOUNT_PRODUCT_TYPE } from '../../../../../config/constants';
import { DiscountCodeDtoPropType } from '../proptypes/DiscountCodeProptypes';
import { tzNormalizeDate } from '../../../../../utils/date';
import { DATE_FORMAT } from '../../../../../config/locale';

const DiscountCodeBasicInformationResource = ({ discountCode }) => {
  const {
    name,
    code,
    discountType,
    discount,
    maxAmount,
    isValid,
    numberOfUses,
    maxNumberOfUses,
    serviceType,
    validFrom,
    validUntil,
    discountCodeCategory,
    authorizerUser,
    productType,
  } = discountCode || {};

  return (
    <>
      <ResourceProperty label="Nombre:">{name || '-'}</ResourceProperty>
      <ResourceProperty label="Código:">{code || '-'}</ResourceProperty>
      <ResourceProperty label="Tipo de Descuento:">
        {discountType
          ? DISCOUNT_CODE_TYPE[discountType].label || discountType
          : '-'}
      </ResourceProperty>
      <ResourceProperty label="Descuento:">
        {discount === 0 || discount ? `${discount}%` : '-'}
      </ResourceProperty>
      <ResourceProperty label="Monto Máximo:">
        {maxAmount === 0 || maxAmount ? maxAmount : '-'}
      </ResourceProperty>
      <ResourceProperty label="Estado:">
        {isValid ? 'Activo' : 'Inactivo'}
      </ResourceProperty>
      <ResourceProperty label="Número de Usos:">
        {numberOfUses === 0 || numberOfUses ? numberOfUses : '-'}
      </ResourceProperty>
      <ResourceProperty label="Límite de Usos:">
        {maxNumberOfUses === 0 || maxNumberOfUses ? maxNumberOfUses : '-'}
      </ResourceProperty>
      <ResourceProperty label="Tipo de Servicio:">
        {serviceType ? serviceType.name : '-'}
      </ResourceProperty>
      <ResourceProperty label="Usuario Autorizador:">
        {authorizerUser ? authorizerUser.fullName : '-'}
      </ResourceProperty>
      <ResourceProperty label="Categoría de Descuento:">
        {discountCodeCategory ? discountCodeCategory.name : '-'}
      </ResourceProperty>
      <ResourceProperty label="Válido Desde:">
        {tzNormalizeDate({ date: validFrom, format: DATE_FORMAT }) || '-'}
      </ResourceProperty>
      <ResourceProperty label="Válido Hasta:">
        {tzNormalizeDate({ date: validUntil, format: DATE_FORMAT }) || '-'}
      </ResourceProperty>
      <ResourceProperty label="Tipo de Producto:">
        {productType
          ? DISCOUNT_PRODUCT_TYPE[productType].label || productType
          : '-'}
      </ResourceProperty>
    </>
  );
};

DiscountCodeBasicInformationResource.propTypes = {
  discountCode: DiscountCodeDtoPropType,
};

DiscountCodeBasicInformationResource.defaultProps = {
  discountCode: null,
};

export default DiscountCodeBasicInformationResource;
